import NotificationSettingEditModal from './NotificationSettingEditModal.vue';

export default NotificationSettingEditModal;
